// The "RBP NPR item" pill (`rbpCartLabel`): the RBP programme's check mark, then the words, as
// SL1.0 draws it under a cart line (`cabinet_smanager_cart_department.htm:226-232`, the
// `rbp-logo` circle then "RBP NPR item"). Story 18.18 (ADO-4037): one pill for every surface that
// shows the mark (the cart and review rows, the product card), each giving it its own pill class,
// as each does for the core mark. The glyph is decorative: the words name the mark.
import { Icon } from '../design-system';
import { RBP_CART_LABEL } from './rbpCartMarker';

export function RbpNprPill({ className }: { readonly className: string | undefined }) {
  return (
    <span className={className} data-rbp-pill="">
      <Icon name="checkCircle" size={12} />
      {RBP_CART_LABEL}
    </span>
  );
}
